import { createAction, createReducer } from "@reduxjs/toolkit";

const initialState = {
  allPhotos: [],
  loading: false,
  error: false,
};

const getAllPhotosRequest = createAction("getAllPhotosRequest");
const getAllPhotosSuccess = createAction("getAllPhotosSuccess");
const getAllPhotosFailure = createAction("getAllPhotosFailure");

export const galleryReducer = createReducer(initialState, (builder) => {
  builder
    // Get All Photos
    .addCase(getAllPhotosRequest, (state) => {
      state.loading = true;
    })
    .addCase(getAllPhotosSuccess, (state, action) => {
      state.loading = false;
      state.allPhotos = action.payload;
    })
    .addCase(getAllPhotosFailure, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
});
